import isEmpty from 'lodash/isEmpty';
import React, { ComponentType } from 'react';
import type { UISchemaElement } from '@jsonforms/core';
import {
  getAjv,
  JsonFormsCellRendererRegistryEntry,
  JsonFormsRendererRegistryEntry,
  JsonSchema,
  OwnPropsOfRenderer,
} from '@jsonforms/core';
import { JsonFormsDispatch, useJsonForms } from '@jsonforms/react';
import { Grid } from '@mantine/core';
import { Ajv } from 'ajv';

export const renderLayoutElements = (
  elements: UISchemaElement[],
  schema: JsonSchema,
  path: string,
  enabled: boolean,
  renderers?: JsonFormsRendererRegistryEntry[],
  cells?: JsonFormsCellRendererRegistryEntry[]
) => {
  return elements.map((child, index) => (
    <Grid.Col key={`${path}-${index}`}>
      <JsonFormsDispatch
        uischema={child}
        schema={schema}
        path={path}
        enabled={enabled}
        renderers={renderers}
        cells={cells}
      />
    </Grid.Col>
  ));
};

export interface MantineLayoutRendererProps extends OwnPropsOfRenderer {
  elements: UISchemaElement[];
  direction: 'row' | 'column';
}
const MantineLayoutRendererComponent = ({
  visible,
  elements,
  schema,
  path,
  enabled,
  direction,
  renderers,
  cells,
}: MantineLayoutRendererProps) => {
  if (isEmpty(elements) || !visible) {
    return null;
  } else {
    return (
      <Grid w='100%' gutter={direction === 'row' ? 2 : 1}>
        {renderLayoutElements(elements, schema!, path!, enabled!, renderers, cells)}
      </Grid>
    );
  }
};
export const MantineLayoutRenderer = React.memo(MantineLayoutRendererComponent);

export interface AjvProps {
  ajv: Ajv;
}

export const withAjvProps = <P extends {}>(Component: ComponentType<AjvProps & P>) =>
  function WithAjvProps(props: P) {
    const ctx = useJsonForms();
    const ajv = getAjv({ jsonforms: { ...ctx } });

    // @ts-ignore
    return <Component {...props} ajv={ajv} />;
  };

export interface MantineLabelableLayoutRendererProps extends MantineLayoutRendererProps {
  label?: string;
}
